import { render } from "./ModalDepartement.vue?vue&type=template&id=037e2094"
import script from "./ModalDepartement.vue?vue&type=script&lang=js"
export * from "./ModalDepartement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__